import React from 'react';
import { InputGroup, FormGroup, Dialog, Classes, Intent, Button } from "@blueprintjs/core";
import { translate } from "utlis/translations/i18n";
import Session from 'services/Session';

class DialogCreateParticipant extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            createParticipantInfos: {},
            isNameUsed: false, 
            isNameTooShort: false,
            isOpen: this.props.isOpen 
        };
    }
   
    handleChangeInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        const { createParticipantInfos } = this.state;
        //Enlever les warnings quand l'input est modifié
        this.setState({ createParticipantInfos: { ...createParticipantInfos, [name]: value },
            isNameUsed: false,
            isNameTooShort: false,
        });
    }
  
    handleCreateParticipant = () => {
        const { id, author } = this.props;
        const { createParticipantInfos } = this.state;
         // Mettre à jour l'état si le nom est trop court
        if (createParticipantInfos.name.length < 3 || createParticipantInfos.name.length > 12) {
            this.setState({ isNameTooShort: true }); 
            return;
        }  
        // Appeler getParticipantNames et stocker les noms déja créé dans un tableau
        Session.getParticipantNames(id, author)
            .then(participantObjects => {
                // Convertir l'objet participantObjects en un tableau de noms de participants
                const participantNames = Object.values(participantObjects).map(obj => obj.participantName);
                // Vérifier si le nom du participant est déjà utilisé et modifer l'état si c'est le cas
                if (participantNames.includes(createParticipantInfos.name)) {
                    this.setState({ isNameUsed: true });
                    return;
                }
                // Créer un nouveau participant
                this.props.onCreateParticipant(createParticipantInfos);
            });
    }

    render() {
        const { isOpen, createParticipantInfos } = this.state;

        return (
            <Dialog
                isOpen={isOpen}
                title={translate('beforeWeStart')}
                icon="info-sign"
                canEscapeKeyClose={false}
                canOutsideClickClose={false}
                isCloseButtonShown={false}>
                <div className={Classes.DIALOG_BODY}>
                    <FormGroup
                        label={translate('confidentiallyReasonPutNickname')}
                        labelFor="name">
                        <InputGroup 
                            id="name" 
                            name="name" 
                            onChange={this.handleChangeInput}
                            onKeyDown={event => {
                                if (event.key === 'Enter') {
                                    this.handleCreateParticipant();
                                }
                            }}
                            />
                    </FormGroup>
                    {this.state.isNameUsed && (  // Afficher le message d'erreur si le nom est déjà utilisé
                        <p style={{ color: 'red' }}>{translate("nicknameInUse")}</p>
                    )}
                    {this.state.isNameTooShort && (
                        <p style={{ color: 'red' }}>{translate("nicknameTooShort")}</p>
                    )}
                </div>
                
                <div className={Classes.DIALOG_FOOTER}>
                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Button
                            text={translate('next')}
                            rightIcon="chevron-right"
                            disabled={(createParticipantInfos.name == null || createParticipantInfos.name.length === 0)}
                            intent={Intent.SUCCESS}
                            onClick={this.handleCreateParticipant} />
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default DialogCreateParticipant;